import { Navigate } from "../../../../router-utils"

export default function AdminCreditConsumptionIndexPage() {
	return <Navigate to="/admin/credit-consumption/all" replace />
}
